export default __webpack_public_path__ + "src/images/slider/2c51c8c6468679ad7127f96484170b1e-4.jpg";